import { api } from "lwc";

import { Variant } from "tds/button";
import ButtonIcon from "tds/buttonIcon";

export default class extends ButtonIcon {
  @api href: string | null = null;
  @api rel: string | null = null;
  @api target: "_self" | "_blank" | "_parent" | "_top" | null = null;
  @api variant: Variant = "tertiary";
}
